import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Grid, Dialog, DialogTitle,
  DialogActions, DialogContent,
  InputLabel, Typography,
} from '@mui/material';

import MultiSelect from './multi-select';
import {
  DEPLOYMENT_STATUSES, POSSESSION_STATUSES,
  getDeploymentStatusReadable, getPossessionStatusReadable,
} from '../../lib/utils';
import { modalStyles } from '../../lib/styles';

const DEFAULT_OPTION = 'No changes';

function BulkVehicleStatus({
  open, handleSave, handleClose, count,
}) {
  const [selectedDeploymentReason, setSelectedDeploymentReason] = useState(undefined);
  const [selectedPossessionReason, setSelectedPossessionReason] = useState(undefined);

  const deploymentOptions = DEPLOYMENT_STATUSES.map((status) => ({
    value: status,
    label: getDeploymentStatusReadable(status),
    isDisabled: false,
  }));
  const possessionOptions = POSSESSION_STATUSES.map((status) => ({
    value: status,
    label: getPossessionStatusReadable(status),
    isDisabled: false,
  }));
  const noChanges = { value: '', label: DEFAULT_OPTION };
  deploymentOptions.unshift(noChanges);
  possessionOptions.unshift(noChanges);
  if (open && count < 1) {
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        disableEnforceFocus
      >
        <DialogContent>
          <Typography variant="subtitle1">Please Select Scooters</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      PaperProps={{ sx: modalStyles.dialog }}
      disableEnforceFocus
    >
      <DialogTitle>
        <Typography variant="h6" component="span">Change Status</Typography>
        <br />
        <Typography variant="subtitle2" component="span">
          {`${count} vehicle${count === 1 ? '' : 's'} selected`}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Grid spacing={2} container direction="row">
          <Grid item xs={12} md={6}>
            <Grid item sx={modalStyles.relative}>
              <InputLabel sx={modalStyles.label}>Deployment</InputLabel>
              <MultiSelect
                isSingle
                placeholder={DEFAULT_OPTION}
                value={[selectedDeploymentReason]}
                handleChange={(newStatus) => setSelectedDeploymentReason(newStatus)}
                options={deploymentOptions}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid item sx={modalStyles.relative}>
              <InputLabel sx={modalStyles.label}>Possession</InputLabel>
              <MultiSelect
                isSingle
                placeholder={DEFAULT_OPTION}
                value={[selectedPossessionReason]}
                handleChange={(newStatus) => setSelectedPossessionReason(newStatus)}
                options={possessionOptions}
              />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={() => handleSave(selectedDeploymentReason, selectedPossessionReason)} color="primary">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}

BulkVehicleStatus.propTypes = {
  open: PropTypes.bool.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
};

export default BulkVehicleStatus;
